import React, { Component } from 'react';
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";

class RealtimeDatafeedTableItem extends Component {

  getColor = (alarmStatus, tag) => {
      if(alarmStatus === 0){
        return '#00a65a';
      }else{
        return '#f39c12';
      }
  }

  getAlarmName = (alarmStatus, tag) => {
        if(alarmStatus === 0){
        return 'OK';
        }else{
        return 'DELAYED > 2h';
        }
    }

    getValue = (value) => {
          var options = { day:'2-digit', month: 'short', year:'2-digit', hour:  "2-digit",
          minute: "2-digit",
          second: "2-digit"};
          //var options2 = { day:'2-digit', month: 'short', year:'2-digit'};
          const date =  new Date(value);
          return  date.toLocaleString('en-GB', options);
      }

    render() {
        return (
            <TableRow 
                style= {
                    {
                        fontSize: '1.3rem'
                    }
                }
                key={this.props.register.id}>
                    <td>{this.props.register.name}</td>
                    <td style={{textAlign: 'center'}}>{this.getValue(this.props.register.value)}</td>
                    <td style={{textAlign: 'center'}}>{this.props.register.commsFailureWells}</td>
                    <td style={{textAlign: 'center'}} > <Button
                      style= {
                        {
                          color:'white',
                          backgroundColor: this.getColor(this.props.register.alarmStatus),
                          fontSize: '1rem',
                          fontFamily: 'Open Sans',
                          textTransform: 'none'
                        }}
                    >
                      {
                        this.getAlarmName(this.props.register.alarmStatus)
                      }
                    </Button></td>
            </TableRow>
        );
    }
}

export default RealtimeDatafeedTableItem;


// WEBPACK FOOTER //
// ./src/components/RealtimeDatafeedTableItem.js